
function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

export const Config = findGetParameter("env") !== 'dev' ? {
    ENDPOINT : "chotto.chat",
    HTTPS: true,
} :  {
    ENDPOINT : "localhost:8787",
    HTTPS: false,
}